/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Cli_LeadInputs */

const en_hub_cli_lead = /** @type {(inputs: Hub_Cli_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import an existing spec repo, or pull any plan out in the format your team works in.`)
};

const id_hub_cli_lead = /** @type {(inputs: Hub_Cli_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impor repo spesifikasi yang sudah ada, atau tarik rencana mana pun dalam format yang dipakai tim Anda.`)
};

/**
* | output |
* | --- |
* | "Import an existing spec repo, or pull any plan out in the format your team works in." |
*
* @param {Hub_Cli_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_cli_lead = /** @type {((inputs?: Hub_Cli_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Cli_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_cli_lead(inputs)
	return en_hub_cli_lead(inputs)
});